import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

import { DateRangePickerComponent } from '../modules/measure/components/date-range-picker/date-range-picker.component';
import { ActiveAccountComponent } from './components/active-account/active-account.component';
import { BillableAccountComponent } from './components/billable-account/billable-account.component';
import { CloudServiceAgreementComponent } from './components/cloud-service-agreement/cloud-service-agreement.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { OneColumnModalComponent } from './components/one-column-modal/one-column-modal.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { RestrictedAccessComponent } from './components/restricted-access/restricted-access.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SuccessModalComponent } from './components/success-modal/success-modal.component';
import { WarningModalComponent } from './components/warning-modal/warning-modal.component';
import { CanAccessDirective } from './directive/can-access.directive';
import { FilterPipe } from './pipes/filter.pipe';
import { SortArrPipe } from './pipes/sort-arr.pipe';
import { StrReplacePipe } from './pipes/str-replace.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { SharedRoutingModule } from './shared-routing.module';
import { SortByKeyPipe } from './pipes/sort-by-key.pipe';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ImpersonationBannerComponent } from './components/impersonation-banner/impersonation-banner.component';

@NgModule({ declarations: [
        ConfirmDialogComponent,
        CanAccessDirective,
        PageNotFoundComponent,
        ActiveAccountComponent,
        FeedbackComponent,
        StrReplacePipe,
        TruncatePipe,
        WarningModalComponent,
        SuccessModalComponent,
        FilterPipe,
        PaginatorComponent,
        SpinnerComponent,
        DateRangePickerComponent,
        SortArrPipe,
        OneColumnModalComponent,
        CloudServiceAgreementComponent,
        RestrictedAccessComponent,
        BillableAccountComponent,
        SortByKeyPipe,
        ImpersonationBannerComponent,
    ],
    exports: [
        CommonModule,
        CanAccessDirective,
        MatSnackBarModule,
        ActiveAccountComponent,
        FeedbackComponent,
        PaginatorComponent,
        WarningModalComponent,
        SuccessModalComponent,
        StrReplacePipe,
        TruncatePipe,
        FilterPipe,
        SpinnerComponent,
        DateRangePickerComponent,
        SortArrPipe,
        CloudServiceAgreementComponent,
        PageNotFoundComponent,
        ImpersonationBannerComponent,
        BillableAccountComponent,
        SortByKeyPipe,
    ], imports: [CommonModule,
        MatSnackBarModule,
        MatDialogModule,
        MatButtonModule,
        SharedRoutingModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatDividerModule,
        MatRadioModule,
        FormsModule,
        ReactiveFormsModule,
        MatMenuModule,
        MatIconModule,
        MatCheckboxModule,
        MatNativeDateModule,
        MatDatepickerModule,
        FlexLayoutModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class SharedModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedModule,
      providers: [],
    };
  }
}
